import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export class QualificationModalState extends Record<{
    readonly isVisible: boolean;
    readonly institutionSetId?: string;
    readonly employeeId?: string;
    readonly qualificationAssignmentId?: string;
    readonly selectedTypeId?: string;
    readonly canEdit: boolean;
    readonly canDelete: boolean;
    readonly refetchQuery: any;
}>({
    isVisible: false,
    institutionSetId: undefined,
    employeeId: undefined,
    qualificationAssignmentId: undefined,
    selectedTypeId: undefined,
    canEdit: false,
    canDelete: false,
    refetchQuery: {},
}) {}

export default makeReducer<QualificationModalState>(
    [
        match(Actions.showNew, (state, {payload}) => {
            return state.merge({
                isVisible: true,
                employeeId: payload.employeeId,
                institutionSetId: payload.institutionSetId,
                refetchQuery: payload.refetchQuery,
            });
        }),
        match(Actions.showExisting, (state, {payload}) => {
            return state.merge({
                isVisible: true,
                institutionSetId: payload.institutionSetId,
                qualificationAssignmentId: payload.qualificationAssignmentId,
                canEdit: payload.canEdit,
                canDelete: payload.canDelete,
                refetchQuery: payload.refetchQuery,
            });
        }),
        match(Actions.hide, () => {
            return new QualificationModalState();
        }),
        match(Actions.selectType, (state, {payload}) => {
            return state.merge({
                selectedTypeId: payload.typeId,
            });
        }),
    ],
    new QualificationModalState(),
);
